module.exports = __webpack_public_path__ + "static/media/pickup.abffe4de.svg";